// src/i18n.js
import { createI18n } from 'vue-i18n'

// 1. Importer vos fichiers JSON
import fr from './trad/fr.json'
import nl from './trad/nl.json'

// 2. Détecter la langue préférée de l'utilisateur (Optionnel mais recommandé)
function getInitialLocale() {
  const savedLang = localStorage.getItem('userLanguage')
  if (savedLang && ['fr', 'nl'].includes(savedLang)) {
    return savedLang
  }
  const browserLang = navigator.language.split('-')[0]
  return ['fr', 'nl'].includes(browserLang) ? browserLang : 'fr'
}

// 3. Créer l'instance i18n
const i18n = createI18n({
  legacy: false,           // IMPORTANT : Utilise la Composition API de Vue 3
  locale: getInitialLocale(), // Langue active par défaut
  fallbackLocale: 'fr',    // Langue de secours si une clé est manquante
  messages: { fr, nl }     // Toutes vos traductions
})

export default i18n